import { render, staticRenderFns } from "./ProjectAdd.vue?vue&type=template&id=4c8a995a&scoped=true"
import script from "./ProjectAdd.vue?vue&type=script&lang=js"
export * from "./ProjectAdd.vue?vue&type=script&lang=js"
import style0 from "./ProjectAdd.vue?vue&type=style&index=0&id=4c8a995a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8a995a",
  null
  
)

export default component.exports